<template>
  <div class="c-numbers">
    <div class="c-number">
      <img src="@/assets/theme/numbers/n.png">
    </div>
    <div class="c-number">
      <img src="@/assets/theme/numbers/n.png">
    </div>
    <div class="c-number">
      <img src="@/assets/theme/numbers/n.png">
    </div>
    <div class="c-number">
      <img src="@/assets/theme/numbers/n.png">
    </div>
    <div class="c-number">
      <img src="@/assets/theme/numbers/n.png">
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmptyNumbers'
}
</script>
